<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-sheet color="grey darken-3" height="100%" flat class="pa-0">

            <v-container fluid>

                <!-- FILTERS -->
                <v-row class="pt-3 pb-5">
                    <v-col cols="12" md="8">
                        <filter-selector
                                @click="filterClicked"
                                @change="filtersChanged"
                                :filters="recruitmentFilters"
                        ></filter-selector>
                    </v-col>

                    <v-col cols="12" md="4" class="text-right">
                        <!-- DOWNLOAD BUTTON -->
                 <!--       <v-tooltip color="primary" left v-if="hasPermission('view data variables')">
                            <template v-slot:activator="{ on }">
                                <v-btn @click="downloadClicked()" v-on="on" icon>
                                    <v-icon>mdi-download</v-icon>
                                </v-btn>
                            </template>
                            <span>Download to Excel</span>
                        </v-tooltip>-->

                        <!-- REPORTING MODE -->
                        <v-btn-toggle v-model="mode" dense mandatory rounded style="background-color: #555">
                            <v-btn text value="average">
                                Average
                            </v-btn>
                            <v-btn text value="sum">
                                Total
                            </v-btn>
                        </v-btn-toggle>

                        <!-- RELOAD BUTTON -->
                        <v-tooltip color="primary" left v-if="hasPermission('view data variables')">
                            <template v-slot:activator="{ on }">
                                <v-btn @click="reloadClicked()" v-on="on" icon>
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>Force reloading data</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-container>

        </v-sheet>

        <v-data-table
                :headers="getHeaders"
                :items="recruitmentData"
                :footer-props="{itemsPerPageOptions:[10,25,50,-1]}"
                :options="tableOptions"
        >
            <template v-slot:body="{ items }">
                <tbody>
                <tr v-for="item in items" :key="item.name">

                    <td>{{ item.name }}</td>

                    <!-- COUNT -->
                    <td class="text-right" v-show="mode==='sum'">
                        {{ item.count.toLocaleString() }}
                    </td>

                    <!-- COST -->
                    <td class="text-right">
                        {{ accountingCurrencyPrefix }}
                        {{ convertToAccountingCurrency(item.cost, true) }}
                        {{ accountingCurrencyPostfix }}
                    </td>

                    <td class="text-right" v-show="mode==='average'">
                        <v-tooltip color="primary" top>
                            <template v-slot:activator="{ on }">
                                <v-chip v-on="on" color="blue darken-3">{{ item.activeMultiplier.toLocaleString() }}</v-chip>
                            </template>
                            Active panelist count {{ item.countActive.toLocaleString() }} /
                            Panelist count {{ item.count.toLocaleString() }}
                        </v-tooltip>
                    </td>

                    <td class="text-right" v-show="mode==='average'">
                        {{ accountingCurrencyPrefix }}
                        {{ convertToAccountingCurrency(item.costActive, true) }}
                        {{ accountingCurrencyPostfix }}
                    </td>

                    <!-- REVENUE -->
                    <td class="text-right">
                        {{ accountingCurrencyPrefix }}
                        {{ convertToAccountingCurrency(item.revenue, true) }}
                        {{ accountingCurrencyPostfix }}
                    </td>

                    <!-- REWARDED -->
                    <td class="text-right">
                        {{ accountingCurrencyPrefix }}
                        {{ convertToAccountingCurrency(item.rewarded, true) }}
                        {{ accountingCurrencyPostfix }}
                    </td>

                    <td class="text-right">
                        {{ accountingCurrencyPrefix }}
                        {{ convertToAccountingCurrency(item.redeemed, true) }}
                        {{ accountingCurrencyPostfix }}
                    </td>

                    <td class="text-right">
                        {{ accountingCurrencyPrefix }}
                        {{ convertToAccountingCurrency(item.points, true) }}
                        {{ accountingCurrencyPostfix }}
                    </td>
                </tr>
                </tbody>
            </template>
        </v-data-table>

        <footer-note v-if="recruitmentStats.createdAt">
            {{footerNote}}
        </footer-note>

        <footer-note v-if="!recruitmentStats.createdAt">
            Report generating...
        </footer-note>

        <json v-if="debug" :data="recruitmentData"></json>
    </div>

</template>

<script>

    import {mapActions, mapMutations, mapState} from 'vuex';
    import FilterSelector from '../../../components/UI/Filter';
    import {timeDisplay} from '../../../components/mixins/timeDisplayMixin';
    import Json from 'vue-json-pretty';
    import FooterNote from "../../../components/UI/FooterNote";
    import {currencyMixin} from '../../../components/mixins/currencyMixin';

    const vuexModule = 'Financials';

    export default {

        mixins: [timeDisplay,currencyMixin],

        components: {
            FilterSelector,
            Json,
            FooterNote
        },

        data() {
            return {

                debug: false,

                headers: [
                    {text: 'NAME', align: 'left', value: 'name'},
                    {text: 'COUNT', align: 'right', value: 'count'},
                    {text: 'COST', align: 'right', value: 'cost'},
                    {text: 'ACTIVE MULTIPLIER', align: 'right', value: 'activeMultiplier'},
                    {text: 'ACTIVE COST', align: 'right', value: 'costActive'},
                    {text: 'REVENUE', align: 'right', value: 'revenue'},
                    {text: 'REWARDED', align: 'right', value: 'rewarded'},
                    {text: 'REDEEMED', align: 'right', value: 'redeemed'},
                    {text: 'REWARDS LIABILITY', align: 'right', value: 'points'},
                ],

                tableOptions: {
                    sortBy: ['activeMultiplier'],
                    sortDesc: [false],
                },
            }
        },

        computed: {
            ...mapState(vuexModule, [
                'recruitmentFilters',
                'recruitmentData',
                'recruitmentReportingMode',
                'recruitmentStats',
            ]),

            footerNote() {

                let note = '';

                if (this.accountingCurrencyDefined) {
                    note += 'Reported in ' + this.accountingCurrency + '. ';
                } else {
                    note += 'Reported using Reward Points. ';
                }

                return note + 'Report was created ' + this.toHumanFrom(this.recruitmentStats.createdAt) + '.';
            },

            getHeaders() {
                if (this.mode === 'sum') {
                    return this.headers.filter(header => !['ACTIVE COST', 'ACTIVE MULTIPLIER'].includes(header.text));
                } else {
                    return this.headers.filter(header => !['COUNT'].includes(header.text));
                }
            },

            mode: {
                get() {
                    return this.recruitmentReportingMode;
                },
                set(value) {
                    this.setRecruitmentReportingMode(value)
                }
            },

            recruitmentData() {
                return this.recruitmentStats[this.recruitmentReportingMode];
            }
        },

        methods: {

            ...mapMutations(vuexModule, [
                'setRecruitmentReportingMode',
                'setRecruitmentFilters'
            ]),

            ...mapActions(vuexModule, [
                'getRecruitmentStats'
            ]),

            loadData(forceReload = false) {

                this.getRecruitmentStats(forceReload)
                    .then(() => {

                    })
                    .catch(() => {
                        Bus.$emit('flash-message', {
                            message: 'Oops! Recruitment report failed to load!',
                            type: 'error'
                        });
                    });
            },

            filtersChanged(filters) {
                this.setRecruitmentFilters(filters);
                this.loadData();
            },

            filterClicked(filter) {
                // No plain filters in use
            },

            reloadClicked() {
                this.loadData(true);
            },

            downloadClicked() {
                Bus.$emit('flash-message', {message: 'This feature is not yet ready!'});
            }
        },

        mounted() {
            this.loadData();
        },
    }
</script>
